module.exports = __webpack_public_path__ + "img/maury_b1.f773608d.jpg";